import VerifyCustomer from './VerifyCustomer'
export default VerifyCustomer